<style scoped lang="stylus" rel="stylesheet/stylus"></style>
<template>
	<div class="pull-refresh">
		<van-pull-refresh
			:value="value"
			:pulling-text="pullingText"
			:loosing-text="pullLoosingText"
			:loading-text="pullLoadingText"
			:success-text="pullSuccessText"
			:success-duration="pullSuccessDuration"
			:animation-duration="pullAnimationDuration"
			:head-height="pullHeadHeight"
			:disabled="pullDisabled"
			@refresh="pullRefresh"
		>
			<template #pulling>
				<slot name="pulling"></slot>
			</template>
			<template #loosing>
				<slot name="loosing"></slot>
			</template>
			<template #loading>
				<slot name="loading"></slot>
			</template>
			<slot name="default"></slot>
		</van-pull-refresh>
	</div>
</template>

<script>
export default {
	name: 'pullRefresh',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			// 是否处于加载中状态
			type: Boolean,
			default: false
		},
		pullingText: {
			// 下拉过程提示文案
			type: String,
			default: '下拉即可刷新...'
		},
		pullLoosingText: {
			// 释放过程提示文案
			type: String,
			default: '释放即可刷新...'
		},
		pullLoadingText: {
			// 加载过程提示文案
			type: String,
			default: '加载中...'
		},
		pullSuccessText: {
			// 刷新成功提示文案
			type: String,
			default: ''
		},
		pullSuccessDuration: {
			// 刷新成功提示展示时长(ms)
			type: [Number, String],
			default: 500
		},
		pullAnimationDuration: {
			// 动画时长
			type: [Number, String],
			default: 300
		},
		pullHeadHeight: {
			// 顶部内容高度
			type: [Number, String],
			default: 50
		},
		pullDisabled: {
			// 是否禁用下拉刷新
			type: Boolean,
			default: true
		}
	},
	watch: {},
	computed: {},
	data() {
		return {}
	},
	methods: {
		pullRefresh() {
			// 下拉刷新时触发
			this.$emit('change', true)
			this.$emit('pullRefresh')
		}
	}
}
</script>
